import { useMutation } from '@tanstack/react-query'
import { api } from 'api'
import { userCardStore } from 'shared/store/userCard'
import { toaster } from 'uikit/Toaster'

export const useIncomingTransfers = (id: string) => {
  const response = useMutation({
    mutationFn: (dataRequest: any) =>
      api.users.fetchIncomingTransfers(id, {
        limit: 50,
        offset: 0,
        ...dataRequest,
      }),
    onSuccess: (data) => {
      userCardStore.setState((state) => {
        return {
          ...state,
          incomingTransfers: {
            ...state.incomingTransfers,
            list: data,
            loading: false,
          },
        }
      })

      toaster.create({
        description: `Найдено переводов: ${data.length}`,
        variant: 'solid',
        type: 'success',
      })
    },
    onError: (error) => {
      toaster.create({
        title: 'Не удалось получить список входящих переводов',
        description: error?.message,
        type: 'error',
      })
    },
  })

  return response
}
